import { useCallback } from 'react';
import { useRouter } from '~/utils/navigation';
import { PRODUCT_LIVEBETTING, PRODUCT_SPORTSBOOK, PRODUCT_TO_ROUTE_MAP } from './sportsbook-constants.js';
import useRetainDefaultParams from '~/hooks/use-retain-default-params';
/**
 * Returns an object with shape { navigateToProduct }
 * Call it in order to properly route to a sportsbook product
 */
const useSportsbookNavigation = () => {
	const router = useRouter();
	const getLocationWithParams = useRetainDefaultParams();

	const navigateToProductCallback = useCallback(
		product => {
			// Lobby
			router.push(getLocationWithParams(PRODUCT_TO_ROUTE_MAP[product]));
		},
		[router, getLocationWithParams]
	);

	return {
		navigateToProduct: navigateToProductCallback,
		navigateToSportsbook: useCallback(
			() => navigateToProductCallback(PRODUCT_SPORTSBOOK),
			[navigateToProductCallback]
		),
		navigateToLiveBetting: useCallback(
			() => navigateToProductCallback(PRODUCT_LIVEBETTING),
			[navigateToProductCallback]
		)
	};
};

export default useSportsbookNavigation;
